module.exports = __webpack_public_path__ + "static/rahma-dd01176a3bd93d1b5fc0f1473d0421c7.mp4";